import { connect } from 'react-redux';
import { compose, lifecycle, setDisplayName, withHandlers } from 'recompose';

import { omitProps } from '../../../common/helpers/props';
import { fetchBrandItems } from '../actions';
import { getActiveShopBrandId } from '../../../auth/selectors';

const categoriesProvider = compose(
  setDisplayName('categoriesProvider'),
  connect(state => ({ brandId: getActiveShopBrandId(state) }), { fetchBrandItems }),
  withHandlers({
    fetchCategories: props => () => props.fetchBrandItems(props.brandId),
  }),
  lifecycle({
    componentDidMount() {
      this.props.fetchCategories();
    },
  }),
  omitProps(['fetchCategories']),
);

export default categoriesProvider;
